"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayAll = ArrayAll;
exports.books = void 0;
exports.clamp = clamp;
exports.ensureCached = ensureCached;
exports.fileExtensionFromPath = fileExtensionFromPath;
exports.fileExtensionFromUrl = fileExtensionFromUrl;
exports.findClosest = findClosest;
exports.friendlyScriptureRef = friendlyScriptureRef;
exports.keyFromScripture = exports.interpolate = exports.fullScreenEnabled = void 0;
exports.mod = mod;
exports.scriptureFromKey = exports.objectMap = exports.objectFilter = void 0;
exports.toHHMMSS = toHHMMSS;
exports.toTitleCase = toTitleCase;
exports.toggleFullscreen = void 0;
exports.useBoundingBox = useBoundingBox;
exports.useRefListener = exports.useKeydownListener = exports.useForwardedRef = void 0;
exports.valueAfter = valueAfter;
exports.valuesAfter = valuesAfter;

var _react = _interopRequireDefault(require("fast-deep-equal/es6/react"));

var _react2 = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var books = ['Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy', 'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel', '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles', 'Ezra', 'Nehemiah', 'Esther', 'Job', 'Psalm', 'Proverbs', 'Ecclesiastes', 'Song of Solomon', 'Isaiah', 'Jeremiah', 'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel', 'Amos', 'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah', 'Haggai', 'Zechariah', 'Malachi', 'Matthew', 'Mark', 'Luke', 'John', 'Acts', 'Romans', '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians', 'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians', '1 Timothy', '2 Timothy', 'Titus', 'Philemon', 'Hebrews', 'James', '1 Peter', '2 Peter', '1 John', '2 John', '3 John', 'Jude', 'Revelation'];
exports.books = books;

var keyFromScripture = function keyFromScripture(book, chapter, verses) {
  if (chapter) {
    if (verses) {
      // all exist
      var _verses$split = verses.split('-'),
          _verses$split2 = _slicedToArray(_verses$split, 2),
          startVerse = _verses$split2[0],
          endVerse = _verses$split2[1];

      return "".concat(String(books.indexOf(book)).padStart(2, '0'), "-").concat(String(chapter).padStart(3, '0'), "-").concat(String(startVerse).padStart(3, '0'), "-").concat(String(endVerse).padStart(3, '0'));
    } // book, chap, no verses


    return "".concat(String(books.indexOf(book)).padStart(2, '0'), "-").concat(String(chapter).padStart(3, '0'));
  } // only book


  return "".concat(String(books.indexOf(book)).padStart(2, '0'));
};

exports.keyFromScripture = keyFromScripture;

var scriptureFromKey = function scriptureFromKey(key) {
  var r = key.split('-');

  if (r.length == 4) {
    return {
      book: books[Number(r[0])],
      chapter: Number(r[1]),
      verses: "".concat(Number(r[2]), "-").concat(Number(r[3]))
    };
  }

  if (r.length == 2) {
    return {
      book: books[Number(r[0])],
      chapter: Number(r[1])
    };
  }

  if (r.length == 1) {
    return {
      book: books[Number(r[0])]
    };
  }
};

exports.scriptureFromKey = scriptureFromKey;

function friendlyScriptureRef(key) {
  var s = scriptureFromKey(key);
  var ref = s.book;
  if (s.chapter) ref += ' ' + s.chapter;
  if (s.verses) ref += ':' + s.verses;
  return ref;
} // this is a mathematically correct mod accounting for negative numbers
// mod(n, m) returns i where 0 <= i < m, where n - i is divisible by m


function mod(n, m) {
  var tmp = n % m;
  return tmp >= 0 ? tmp : tmp + m;
}

function valueAfter(arr, val) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var returnIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isVal = function isVal(a) {
    return (0, _react.default)(a, val);
  };

  if (!val instanceof Function) isVal = val;

  for (var i in arr) {
    i = Number(i); // apparently i is a string

    if (isVal(arr[i])) {
      i = mod(i + n, arr.length);
      if (returnIndex) return i;
      return arr[i];
    }
  }

  return arr[0];
}

function valuesAfter(arr, val, N) {
  var wrap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  N = Math.min(N, arr.length);
  if (!val) return arr.slice(0, N);
  var i = valueAfter(arr, val, 1, true);
  if (!wrap || i + N < arr.length) return arr.slice(i, i + N);else return [].concat(_toConsumableArray(arr.slice(i, i + N)), _toConsumableArray(arr.slice(0, i + N - arr.length)));
}

function findClosest(list, value) {
  var returnIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var len = list.length; // short circuit simplest cases

  if (len == 0) return undefined;
  if (len == 1) return list[0]; // find index where value is in interval [i, i-1]

  list.sort(function (a, b) {
    return a - b;
  });
  var i = 0;

  while (i < len && list[i] < value) {
    i++;
  } // return the correct one of i, (i-1)


  var index;
  if (i == len || list[i] - value > value - list[i - 1]) index = i - 1;else index = i;

  if (returnIndex) {
    return [list[index], index];
  } else {
    return list[index];
  } // if(i == len) return list[i-1]
  // if(list[i] - value > value - list[i-1]) return list[i-1]
  // return list[i]

}

function toTitleCase(str) {
  return str.trim().replace(/\b[a-z]|['_][a-z]|\B[A-Z]/g, function (x) {
    return x[0] === "'" || x[0] === "_" ? x : String.fromCharCode(x.charCodeAt(0) ^ 32);
  });
}

function toHHMMSS(sec) {
  var min, hour;
  var _ref = [Math.floor(sec / 3600), Math.floor(sec / 60) % 60, sec % 60];
  hour = _ref[0];
  min = _ref[1];
  sec = _ref[2];
  if (hour) return "".concat(hour, ":").concat(min.padStart(2, '0'), ":").concat(sec.toFixed(0).padStart(2, '0'));
  return "".concat(min, ":").concat(sec.toFixed(0).padStart(2, '0'));
}

function fileExtensionFromUrl(url) {
  return new URL(url).pathname.split('.').slice(-1)[0];
}

function fileExtensionFromPath(path) {
  return path.split('.').slice(-1)[0];
} // as seen in https://non-traditional.dev/how-to-use-the-forwarded-ref-in-react-1fb108f4e6af


var useForwardedRef = function useForwardedRef(ref) {
  var innerRef = (0, _react2.useRef)(null);
  (0, _react2.useEffect)(function () {
    if (!ref) return;

    if (typeof ref === "function") {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  });
  return innerRef;
};

exports.useForwardedRef = useForwardedRef;

var objectMap = function objectMap(obj, fn) {
  return Object.fromEntries(Object.entries(obj).map(function (_ref2, i) {
    var _ref3 = _slicedToArray(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];

    return fn(k, v, i);
  }));
};

exports.objectMap = objectMap;

var objectFilter = function objectFilter(obj, fn) {
  return Object.fromEntries(Object.entries(obj).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        k = _ref5[0],
        v = _ref5[1];

    return fn(k, v);
  }));
};

exports.objectFilter = objectFilter;

var interpolate = function interpolate(x, y, t) {
  return x - x * t + y * t;
};

exports.interpolate = interpolate;

var useRefListener = function useRefListener(ref, event, callback) {
  var deps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  (0, _react2.useEffect)(function () {
    var cur = ref.current;

    if (cur) {
      cur.addEventListener(event, callback);
      return function () {
        return cur.removeEventListener(event, callback, options);
      };
    }
  }, [ref].concat(_toConsumableArray(deps)));
};

exports.useRefListener = useRefListener;

var useKeydownListener = function useKeydownListener(ref, callback) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  (0, _react2.useEffect)(function () {
    var cur = ref.current;

    if (cur) {
      cur.tabIndex = 0; // keydown wont work if you cant focus on the element

      cur.addEventListener('keydown', callback, options);
      return function () {
        return cur.removeEventListener('keydown', callback);
      };
    }
  }, [ref].concat(_toConsumableArray(deps)));
};

exports.useKeydownListener = useKeydownListener;

var fullScreenEnabled = function fullScreenEnabled() {
  return !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.webkitSupportsPresentationMode);
};

exports.fullScreenEnabled = fullScreenEnabled;

var toggleFullscreen = function toggleFullscreen(node) {
  if (isFullScreen()) {
    if (document.exitFullscreen) document.exitFullscreen();else if (document.mozCancelFullScreen) document.mozCancelFullScreen();else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();else if (document.msExitFullscreen) document.msExitFullscreen();else if (document.webkitSetPresentationMode) document.webkitSetPresentationMode("inline");
    return false;
  } else {
    if (node.requestFullscreen) node.requestFullscreen();else if (node.mozRequestFullScreen) node.mozRequestFullScreen();else if (node.webkitRequestFullScreen) node.webkitRequestFullScreen();else if (node.msRequestFullscreen) node.msRequestFullscreen();else if (node.webkitSetPresentationMode) node.webkitSetPresentationMode("fullscreen");
    return true;
  }
};

exports.toggleFullscreen = toggleFullscreen;

var isFullScreen = function isFullScreen() {
  return !!(document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
};

function ArrayAll(arr) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  return arr.reduce(function (prev, cur) {
    return prev && fn(cur);
  }, true);
}

function ensureCached(_x) {
  return _ensureCached.apply(this, arguments);
}

function _ensureCached() {
  _ensureCached = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var cache, request, match;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(url && self.caches)) {
              _context.next = 9;
              break;
            }

            _context.next = 3;
            return caches.open("media");

          case 3:
            cache = _context.sent;
            request = new Request(url, {
              mode: "cors"
            });
            _context.next = 7;
            return cache.match(request);

          case 7:
            match = _context.sent;

            if (!match) {
              cache.add(request).catch(function (e) {
                return console.error("cache add failed", e);
              });
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ensureCached.apply(this, arguments);
}

function clamp(val, min, max) {
  if (val < min) return min;
  if (val > max) return max;
  return val;
}

function useBoundingBox(ref) {
  var _useState = (0, _react2.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      rect = _useState2[0],
      setRect = _useState2[1]; // update on ref change


  (0, _react2.useEffect)(function () {
    setRect(ref.current.getBoundingClientRect());
  }, [ref]); // update on resize

  (0, _react2.useEffect)(function () {
    function onResize(e) {
      setRect(ref.current.getBoundingClientRect());
    }

    window.addEventListener("resize", onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, []);
  return rect;
} // hash from https://stackoverflow.com/a/52171480


var hash = function hash(str) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var h1 = 0xdeadbeef ^ seed,
      h2 = 0x41c6ce57 ^ seed;

  for (var i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }

  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
  return (h2 >>> 0).toString(16).padStart(8, 0) + (h1 >>> 0).toString(16).padStart(8, 0);
};